import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionCalendar } from '../components/collectes/CollectionCalendar';
import { DayDetails } from '../components/collectes/DayDetails';
export function CalendrierCollectes() {
  const [month, setMonth] = useState(new Date(2026, 8, 1));
  const [selected, setSelected] = useState(new Date(2026, 8, 10));
  const handleSelect = (date: Date) => {
    setSelected(date);
    if (date.getMonth() !== month.getMonth()) setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
  };
  return <main className="bg-white" data-id="element-1909" data-mp="29vh96i07e0iy">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1910" data-mp="akploles99lu">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-1911" data-mp="amsjhrm6g714">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1912" data-mp="352563eqnd4t1">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1913" data-mp="30awy8n4ytrhz" />
          <Link to="/my-collections" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1914" data-mp="309lu2m7lyhqc">
            My Collections
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1915" data-mp="2rbs03hxbg06c" />
          <span aria-current="page" data-id="element-1916" data-mp="3o0r9j09mz804">Calendar</span>
        </nav>

        <Link to="/my-collections" className="mt-5 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1917" data-mp="3nywuu3oykc4h">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1918" data-mp="23lp97555109b" />
          Back to My Collections
        </Link>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-1919" data-mp="1yltbtoqy472q">
          <div data-id="element-1920" data-mp="202qfxhe518cu">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1921" data-mp="2049w77zsnjem">My Collections</h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-1922" data-mp="2510d1xjfaj13">A calendar tailored to your address</p>
          </div>
        </header>

        <div className="mt-8" data-id="element-1923" data-mp="1r4msgfjle1ie">
          <AtnaAssistant data-id="element-1924" data-mp="1v3vppuduchip" />
        </div>

        <div className="mt-6" data-id="element-1925" data-mp="1v2kifkl6srmu">
          <AddressCard data-id="element-1926" data-mp="1v601szlw8mu2" />
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-10" data-id="element-1927" data-mp="1hch19815zo49">
          <CollectionCalendar month={month} selected={selected} onMonthChange={setMonth} onSelect={handleSelect} data-id="element-1928" data-mp="1m3qq46ew2nf3" />
          <DayDetails date={selected} data-id="element-1929" data-mp="17fm8z6vhijyf" />
        </div>
      </div>
    </main>;
}